module.exports = __webpack_public_path__ + "static/img/qrcode.69fca05e.jpg";